import { useTranslation } from "@repo/shared/i18n";
import { useState } from "react";

// A quote only where we have a real one to attribute.
const ITEMS: {
  key: "packs" | "squads" | "tracking";
  quote?: {
    key: "packs" | "squads" | "tracking";
    source: "reddit" | "discord" | "inbox";
  };
}[] = [
  { key: "packs", quote: { key: "packs", source: "reddit" } },
  { key: "squads", quote: { key: "squads", source: "discord" } },
  { key: "tracking", quote: { key: "tracking", source: "inbox" } },
];

export const ObjectivesFaq = () => {
  const { t } = useTranslation("objectives");
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="flex flex-col border-t border-white/8">
      {ITEMS.map(({ key, quote }, i) => {
        const isOpen = open === i;
        return (
          <div key={key} className="border-b border-white/8">
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? null : i)}
              className="flex w-full items-start justify-between gap-6 py-6 text-left"
            >
              <span className="flex flex-col gap-2">
                <span className="text-lg font-semibold text-neutral-100">
                  {t(`landing.faq.items.${key}.question`)}
                </span>
                {quote && (
                  <span className="text-[13px] text-neutral-500">
                    {t("landing.faq.attributedQuote", {
                      quote: t(`landing.faq.items.${quote.key}.quote`),
                      source: t(`landing.faq.sources.${quote.source}`),
                    })}
                  </span>
                )}
              </span>
              <span
                aria-hidden
                className="grid size-7 flex-none place-items-center rounded-full bg-neutral-800 text-lg leading-none text-neutral-400"
              >
                {isOpen ? "–" : "+"}
              </span>
            </button>
            {isOpen && (
              <p className="-mt-1 mb-6 max-w-[620px] text-base leading-relaxed text-neutral-300">
                {t(`landing.faq.items.${key}.answer`)}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};
